import { z } from 'zod';

/** Ten sam limit, co `@Size(max = 2000)` na `ResolveAttentionFindingsRequest` backendu. */
export const MAX_RESOLUTION_COMMENT_LENGTH = 2000;

/** Komentarz jest wymagany tylko dla kluczy z `commentRequiredOnResolve` — flaga przychodzi z backendu per pozycja. */
export const resolveFindingSchema = (commentRequired: boolean) => {
  const comment = z
    .string()
    .trim()
    .max(
      MAX_RESOLUTION_COMMENT_LENGTH,
      `Komentarz może mieć najwyżej ${MAX_RESOLUTION_COMMENT_LENGTH} znaków`,
    );
  return z.object({
    comment: commentRequired
      ? comment.min(1, 'Komentarz jest wymagany')
      : comment,
  });
};

export type ResolveFindingFormData = z.infer<
  ReturnType<typeof resolveFindingSchema>
>;
